<ul class="list-disc pl-4"><slot /></ul>
